<div class="app-loading-page-wrapper">
  <div class="app-loading-page"></div>
  <div class="loading-text">Loading ...</div>
</div>
